import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { GetLicensedProductsQuery } from './GetLicensedProductsQuery.graphql.ts';

export const preloadGetLicensedProductsQuery = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GetLicensedProductsQuery,
	});
};
